import { isUndefined } from '~/util/validators/baseComponentsValidators'

export default function ({ req, route, redirect }) {
  const path = route.path.replace(/^\/ru(\/|$)/, '/') || '/'

  if (route.path === '/ru' || route.path.startsWith('/ru/')) {
    if (req) {
      const userAgent = req.headers['user-agent'] || ''
      const isBot = /googlebot|google-inspectiontool|bot|crawl|spider/i.test(userAgent)

      if (isBot) return
    }

    return redirect(path)
  }

  // if (!route.fullPath) return
  // const locale = app.i18n.getLocaleCookie()
  // if (isUndefined(locale) || app.i18n.locale === locale) return
  // app.i18n.setLocale(locale)
  // redirect(route.fullPath)
}
